import { SimpleCommand } from "./../../../commanding/SimpleCommand";
import { BasicController } from "../BasicController";
import { BasicModel } from "../../model/BasicModel";
import { NetworkInstance } from "@goodgamestudios/world-assignment";
import { BasicSmartfoxClient } from "../../model/components/BasicSmartfoxClient";
import { getLogger } from "@goodgamestudios/logger";

const logger = getLogger("Connection.BasicConnectClientCommand");
export class BasicConnectClientCommand extends SimpleCommand {
    public execute(): void {
        let instanceVO: NetworkInstance = BasicModel.instanceProxy.selectedInstanceVO;
        if (!instanceVO) {
            logger.error("Network instance is null!");
            return;
        }
        if (BasicModel.smartfoxClient == null) {
            BasicModel.smartfoxClient = new BasicSmartfoxClient();
        }
        logger.info("Connect to: " + instanceVO.instanceId , instanceVO.ip);
        BasicController.getInstance().connectClient(instanceVO.ip, instanceVO.port);
    }

}
